import { createTransform, Transform } from '../transform/createTransform';
import { LivePreviewConfig } from '../helpers/types';

let projectConfig: LivePreviewConfig | undefined;
let transform: Transform | undefined;

export const configureLivePreview = (config: LivePreviewConfig): void => {
  projectConfig = config;
  transform = createTransform(config);
};

const throwNotConfigured = (): never => {
  throw new Error(
    '[live-preview] call configureLivePreview(config) before using live preview'
  );
};

export const getLivePreviewConfig = (): LivePreviewConfig =>
  projectConfig ?? throwNotConfigured();

export const getTransform = (): Transform => transform ?? throwNotConfigured();
